export const CELL_TYPE_STRING = 'string';
export const CELL_TYPE_NUMBER = 'number';
export const validTypes = [CELL_TYPE_STRING, CELL_TYPE_NUMBER];

export const MISSING_KEY_FILENAME = 'Zipclex config missing property filename';
export const INVALID_TYPE_FILENAME = 'Zipclex filename can only be of type string';
export const INVALID_TYPE_SHEET = 'Zipcelx sheet data is not of type array';
export const INVALID_TYPE_SHEET_DATA = 'Zipclex sheet data childs is not of type array';

export const WARNING_INVALID_TYPE = 'Invalid type supplied in cell config, falling back to "string"';
